<template>
	<SOSlotModal
		:modal-id="id"
		:modal-title="'Hapus Transaksi'"
		:no-padding="true"
		@close="close"
	>
		<template v-slot:modal-body>
			<div class="bg-yellow p-x-20 p-y-8 d-flex align-items-center border-bottom">
				<img src="@/assets/icons/alert-circle-yellow.svg" alt="" class="m-r-12">
				<div class="f-regular f-12 f-c-midgrey">
					Menghapus transaksi akan mengubah pencatatan pendapatan, hutang, atau piutang pada akun terkait
					di laporan keuangan Anda.
				</div>
			</div>
			<div class="modal-body">
				<div class="f-regular f-14 f-c-black m-d-12"
				     v-if="transaksi.rincian_pembayaran.filter(v => ewalet.includes(v.jenis_bayar)).length > 0">
					Anda bisa mengubah akun keuangan untuk pengembalian dana
					<b>
						{{
							jenisPembayaran(transaksi.rincian_pembayaran.filter(v => ewalet.includes(v.jenis_bayar))[0].jenis_bayar)
						}}
					</b>
				</div>

				<div class="frame-pembayaran m-d-20" v-if="transaksi.rincian_pembayaran.length > 0">
					<div class="border-bottom p-x-16 p-y-8"
					     v-for="(pembayaran, i) in transaksi.rincian_pembayaran" :key="i"
					>
						<div class="d-flex-between-center f-regular f-14 f-c-black">
							<div>
								{{ jenisPembayaran(pembayaran.jenis_bayar) }}
							</div>
							<div v-if="pembayaran.jenis_bayar === 5">
								{{ pembayaran.jumlah_beli }} {{ pembayaran.satuan }}
							</div>
							<div v-else>
								{{ pembayaran.dibayar | currency }}
							</div>
						</div>
						<div class="f-regular f-14 f-c-midgrey">
							<div v-if="ewalet.includes(pembayaran.jenis_bayar)">
								<div class="d-flex">
									<SODropdownGrouped
										:id="'dropdown-transaksi-deposit'"
										:items="groupedOption"
										:title="selectedAkunKeuangan()"
										:key-replacer="keyReplacer"
										@update-data="(val) => { groupedOption = val }"
										@selected-value="(val) => { selectedIdakun = val }"
									/>
								</div>
							</div>
							<div v-else-if="pembayaran.jenis_bayar === 4 || pembayaran.jenis_bayar === 5">
								Saldo {{ jenisPembayaran(pembayaran.jenis_bayar) }} dikembalikan
							</div>
							<div v-else>
								Di-refund dari kas laci
							</div>
						</div>
					</div>
				</div>

				<SOInputRegular
					:title="'Catatan (Opsional)'"
					:placeholder="'Ketik catatan...'"
					:validation="'alphanumeric'"
					v-model="catatan"
				/>
			</div>
		</template>
		<template v-slot:modal-footer>
			<div class="modal-footer">
				<SOButton
					:text="'Hapus'"
					:outline-danger="true"
					:full="true"
					:loading="pageSetting.btn.del.loading"
					:disable="pageSetting.btn.del.disabled"
					@action="deleteTransaksi()"
				/>
			</div>
		</template>
	</SOSlotModal>
</template>

<script>
import {mapGetters} from "vuex";
import SOSlotModal from "@/so-components/global/slot/SOSlotModal";
import SOInputRegular from "@/so-components/global/input/SOInputRegular";
import SOButton from "@/so-components/global/ui/SOButton";
import SODropdownGrouped from "@/so-components/global/ui/SODropdownGrouped";

export default {
	name: "TransaksiSnapcleanModalHapus",
	props: {
		transaksi: Object,
	},
	components: {
		SOSlotModal,
		SOInputRegular,
		SOButton,
		SODropdownGrouped,
	},
	computed: {
		...mapGetters("metaModule", {
			akunKeuangan: "getAkunKeuangan",
		}),
	},
	data() {
		return {
			id: "modal-hapus-transaksi-snapclean",
			pageSetting: {
				btn: {
					del: {
						disabled: false,
						loading: false,
					}
				}
			},
			catatan: "",
			ewalet: [6, 10],
			groupedOption: {},
			selectedIdakun: "",
			keyReplacer: {
				"1.01.000": "Kas",
				"1.02.000": "Bank",
			}
		}
	},
	mounted() {
		$("#" + this.id).modal("show");
		if (this.transaksi.rincian_pembayaran.filter(v => this.ewalet.includes(v.jenis_bayar)).length > 0) {
			this.getAkunKeuangan()
		}
	},
	methods: {
		close() {
			$("#" + this.id).modal("hide");
			setTimeout(() => {
				this.$emit("close")
			}, 500)
		},
		async deleteTransaksi() {
			this.pageSetting.btn.del.disabled = true
			this.pageSetting.btn.del.loading = true
			const res = await this.$store.dispatch("transaksiSnapcleanModule/deleteTransaksi", {
				id: this.transaksi.detail_transaksi.idtransaksi,
				idakunRefund: this.selectedIdakun,
				keterangan: this.catatan,
			})
			this.pageSetting.btn.del.disabled = false
			this.pageSetting.btn.del.loading = false
			if (res.success) {
				this.close()
				this.$toast.success(res.msg)
				await this.$store.commit("transaksiSnapcleanModule/resetListTransaksiKonsumen")
				this.$router.back()
			} else {
				this.$toast.error(res.err)
			}
		},

		async getAkunKeuangan() {
			const res = await this.$store.dispatch("metaModule/fetchAkunKeuangan", this.transaksi.detail_transaksi.idoutlet)
			if (!res.success) {
				this.$toast.error(res.err)
				return
			}
			let resGroup = this.groupingArray(this.akunKeuangan, "idkategori");
			for (let v in resGroup) {
				let replaceData = []
				resGroup[v].forEach(obj => {
					if (obj.idakun.includes("1.01.8")) {
						replaceData = [...replaceData, {
							title: obj.nama_akun,
							selected: true,
							value: obj.idakun
						}]
						this.selectedIdakun = obj.idakun
					} else {
						replaceData = [...replaceData, {
							title: obj.nama_akun,
							selected: false,
							value: obj.idakun
						}]
					}
				})
				resGroup[v] = replaceData
			}
			this.groupedOption = resGroup
			this.selectedAkunKeuangan()
		},
		selectedAkunKeuangan() {
			for (let key in this.groupedOption) {
				let loopGroupedOption = this.groupedOption[key]
				for (let i = 0; i < loopGroupedOption.length; i++) {
					if (loopGroupedOption[i].selected) {
						return '<span class="f-regular f-14 f-c-blue" style="margin-top: -4px">Di-refund dari ' + loopGroupedOption[i].title + '<span>'
					}
				}
			}
		}
	}
}
</script>

<style scoped>
.frame-pembayaran {
	border-radius: 4px;
	border: 1px solid #C8D0DD;
}
</style>